<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <activity-breadcrumbs :search-request="searchRequest" :product="product" />
        </template>
        <template v-slot:sidebar>
            <activity-order-summary
                :product="product"
                :offers="[offer]"
                :info="basketItem.info"
                :selected-add-ons="selectedAddOns"
                :search-request="searchRequest"
                :extra-services="extraServices"
                :additional-options="bookingAdditionalOptions"
            />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {mixins, Component} from 'vue-facing-decorator'
    import ConfirmationStatus from '~src/components/booking/confirmationStatus.src'
    import ActivityOrderSummary from '@/components/activities/booking/ActivityOrderSummary.vue'
    import {ActivityStoreMixin} from '@/mixins/ActivityStoreMixin.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import {ActivityPageMixin} from '@/components/activities/mixins/ActivityPageMixin.vue'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import ActivityBreadcrumbs from '@/components/activities/ActivityBreadcrumbs.vue'

    @Component({
        components: {
            ActivityBreadcrumbs,
            ConfirmationPageLayout,
            ConfirmationStatus,
            ActivityOrderSummary,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class ActivityConfirmationPage extends mixins(ActivityPageMixin, ActivityStoreMixin, ConfirmationPageMixin) {
        get basketItem() {
            return this.productStore.basketItem(this.productStore.prepareBookRequest.offerKey)
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get product() {
            return this.basketItem.product
        }

        get offer() {
            return this.product.offers.find(offer => offer.offerKey === this.basketItem.offerKey)
        }
    }

    export default ActivityConfirmationPage
</script>
